import { TRAINING_API } from "constants/ApiConstant";
import axiosInstance from "auth/FetchInterceptor";
const TrainingCmeService = {};

TrainingCmeService.search = function (data) {
  return axiosInstance.post(`${TRAINING_API}/Cme/search`, data);
};
TrainingCmeService.searchTracking = function (data) {
  return axiosInstance.post(`${TRAINING_API}/CmeTracking/search`, data);
};

TrainingCmeService.getTrainingCmeThietLapKyTheoDoi = function () {
  return axiosInstance.get(`${TRAINING_API}/Cme/ky-theo-doi`);
};

TrainingCmeService.getById = function (id) {
  return axiosInstance.get(`${TRAINING_API}/Cme/get-by-id?id=${id}`);
};
TrainingCmeService.upSert = function (data) {
  return axiosInstance.post(`${TRAINING_API}/Cme/up-sert`, data);
};

export default TrainingCmeService;
